var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "voice-bg" }, [
    _c(
      "div",
      {
        staticClass: "captions-switch",
        on: {
          click: function ($event) {
            _vm.captionsSwitch = !_vm.captionsSwitch
          },
        },
      },
      [
        _vm.captionsSwitch
          ? _c("span", [_vm._v("关闭字幕")])
          : _c("span", [_vm._v("字幕")]),
      ]
    ),
    _c("div", { staticClass: "voice-animation" }, [
      _c(
        "div",
        {
          staticClass: "leaf",
          style: { animationPlayState: _vm.generating ? "running" : "paused" },
        },
        _vm._l(3, function (item) {
          return _c("i", { key: `leaf-${item}` })
        }),
        0
      ),
      _c(
        "div",
        {
          staticClass: "leaves",
          style: { animationPlayState: _vm.generating ? "running" : "paused" },
        },
        _vm._l(3, function (item) {
          return _c("i", { key: `leaves-${item}` })
        }),
        0
      ),
      _vm._m(0),
    ]),
    _vm.captionsSwitch && _vm.currentCaptions
      ? _c("div", { staticClass: "captions" }, [
          _vm._v(_vm._s(_vm.currentCaptions)),
        ])
      : _vm._e(),
    !_vm.hasPermission
      ? _c("div", { staticClass: "get-permission" }, [
          _c("span", [_vm._v("授权麦克风，开启语音对话")]),
          _c(
            "div",
            { staticClass: "permission-btn", on: { click: _vm.openRecorder } },
            [
              _c("i", { staticClass: "el-icon-microphone" }),
              _vm._v("开启麦克风"),
            ]
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "voice-operation" }, [
      _c("div", {
        ref: "voiceWave",
        staticClass: "voice-wave",
        staticStyle: { width: "100%", height: "40px" },
      }),
      _c("div", { staticClass: "operation-btn" }, [
        _vm.hasPermission && !_vm.micphoneOff
          ? _c("i", {
              staticClass: "el-icon-microphone",
              on: { click: _vm.switchMicphone },
            })
          : _c("i", {
              staticClass: "el-icon-turn-off-microphone red-btn",
              on: { click: _vm.startRecord },
            }),
        _vm.generating
          ? _c("i", {
              staticClass: "stop-icon",
              on: { click: _vm.stopGenerate },
            })
          : _c("i", {
              staticClass: "el-icon-close red-btn",
              on: { click: _vm.backToChats },
            }),
      ]),
    ]),
    _c("audio", {
      ref: "audio",
      attrs: { src: _vm.currentVoice, preload: "auto" },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stamens" }, [_c("i")])
  },
]
render._withStripped = true

export { render, staticRenderFns }